<template>
  <div class="page">
    <div class="business">
      <div class="businessTitle">商务合作</div>
      <div class="businessEn">BECOME A SPONSOR</div>
    </div>
    <div class="businessContent">
      <div class="content-left">
        <div class="left-title">
          <div class="title">马欣</div>
          <div class="zhiwu">商务总监</div>
        </div>
        <div class="left-info">
          <img src="https://p0.ssl.qhimg.com/t110b9a93013917c8393828b74e.png" alt="">
          <div class="info" style="margin-left: 4px;margin-right: 22px;">15718876610</div>
          <img src="https://p5.ssl.qhimg.com/t110b9a9301cb12fc96c711b7f9.png" alt="">
          <div class="info" style="margin-left: 4px;">ISC@360.cn</div>
        </div>
      </div>
      <div class="content-right">
        <img src="https://p4.ssl.qhimg.com/t110b9a930178dffe4bdd04dfc6.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  margin-top: 116px;
  padding: 57px 0 112px;
  .business {
    width: 1400px;
    display: flex;
    flex-direction: column;
      &Title{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 36px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
      }
      &En{
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
        margin-top: 16px;
      }
  }
  .businessContent{
    width: 1400px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 40px;
    .content-left{
      display: flex;
      flex-direction: column;
      .left-title{
        display: flex;
        align-items: flex-end;
        .title{
          color: rgb(44, 44, 44);
          font-family: Source Han Sans;
          font-size: 22px;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
       .zhiwu{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: left;
        text-transform: uppercase;
        margin-left: 12px;
       }
      }
      .left-info{
        display: flex;
        align-items: center;
        margin-top: 22px;
        img{
          height: 25px;
        }
        .info{
          color: rgb(44, 44, 44);
          font-family: HarmonyOS Sans SC;
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0px;
          text-align: left;
          text-transform: uppercase;
        }
      }
    }
    .content-right{
      img{
        height: 138px;
      }
    }
  }
}
</style>
